// src/components/BrowseDiningSessions.jsx (BrowseDiningSessions)
import React, { useEffect, useState, useMemo } from "react";
import "../Details.css";
import "./CustomerData.css";
import "./BrowseDiningSessions.css";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { busyErrorFrom, useDataApiBusy } from "../../services/dataApiBusy";
import BusyNotice from "./BusyNotice";

function BrowseDiningSessions({ periodSelection }) {
  const pageTitle = "Browse Dining Sessions";

  const {
    user,
    tenantServerUrl,
    primaryRestaurantId,
    selectedRestaurantId,
    accessToken,
  } = useAuth();

  const bearerToken = useMemo(() => {
    if (!accessToken) return null;
    return accessToken.startsWith("Bearer ")
      ? accessToken
      : `Bearer ${accessToken}`;
  }, [accessToken]);

  const {
    questionCategoryID: categoryIDParam,
    questionID: questionIDParam,
  } = useParams();
  const navigate = useNavigate();

  const dataCategoryID = "6";
  const categoryID = categoryIDParam;
  const questionID = questionIDParam || "1";

  const RestaurantID = selectedRestaurantId;

  console.log(
    `Route -> dataCategoryID: ${dataCategoryID}, categoryID: ${categoryID}, questionID: ${questionIDParam}`
  );
  console.log("[BrowseDiningSessions] tenantServerUrl:", tenantServerUrl);
  console.log("[BrowseDiningSessions] RestaurantID:", RestaurantID);
  console.log("[BrowseDiningSessions] bearerToken present:", !!bearerToken);

  const [sessionsList, setSessionsList] = useState([]);
  const [ordersList, setOrdersList] = useState([]);
  const [ratingsList, setRatingsList] = useState([]);

  const [isQuestionDataLoading, setIsQuestionDataLoading] = useState(false);
  const [tabID, setSessionTabID] = useState("0");

  // ✅ NEW: track the currently selected session object
  const [selectedSession, setSelectedSession] = useState(null);

  const REDIR_BASE = "https://mydata.tablemate.net/redir.php?url=";

  const [employeeFilterNames, setEmployeeFilterNames] = useState([]);
  const employeeFilterCsv = useMemo(
    () =>
      employeeFilterNames && employeeFilterNames.length
        ? employeeFilterNames.join(",")
        : "",
    [employeeFilterNames]
  );

  // ✅ NEW: local search term for sessions list
  const [sessionSearchTerm, setSessionSearchTerm] = useState("");

  useEffect(() => {
    if (categoryID && !questionIDParam) {
      navigate(`/data/${dataCategoryID}/${categoryID}/1`, { replace: true });
    }
  }, [categoryID, questionIDParam, dataCategoryID, navigate]);

  const formatYMD = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const formatYM = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
  };

  const resolvedPeriod = periodSelection || {
    mode: "today",
    start: null,
    end: null,
  };
  const mode = resolvedPeriod.mode;
  const start = resolvedPeriod.start;
  const end = resolvedPeriod.end;

  const {
    chartPeriod,
    chartDateSelected,
    fromParam,
    toParam,
    periodLabel,
  } = useMemo(() => {
    console.log("BrowseDiningSessions: recomputing period from", {
      mode,
      start,
      end,
    });

    const fmtShort = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });

    const fmtMonthYearLabel = (d) =>
      d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
      });

    let p = "3";
    let dVal = "";
    let from = "";
    let to = "";

    const todayNow = new Date();
    const yyyyNow = todayNow.getFullYear();
    const mmNow = String(todayNow.getMonth() + 1).padStart(2, "0");
    const ddNow = String(todayNow.getDate()).padStart(2, "0");
    const formattedDateTodayNow = `${yyyyNow}-${mmNow}-${ddNow}`;
    let label = `Today - ${formattedDateTodayNow}`;

    if (!start || !end) {
      return {
        chartPeriod: p,
        chartDateSelected: dVal,
        fromParam: from,
        toParam: to,
        periodLabel: label,
      };
    }

    from = formatYMD(start);
    to = formatYMD(end);

    const now = new Date();
    const isCurrentMonth =
      start.getFullYear() === now.getFullYear() &&
      start.getMonth() === now.getMonth();

    const isCurrentYear = start.getFullYear() === now.getFullYear();

    switch (mode) {
      case "month":
        p = "1";
        dVal = formatYM(start);
        label = isCurrentMonth
          ? `This Month - ${fmtMonthYearLabel(start)}`
          : fmtMonthYearLabel(start);
        break;

      case "year":
        p = "2";
        dVal = String(start.getFullYear());
        label = isCurrentYear
          ? `This Year - ${String(start.getFullYear())}`
          : String(start.getFullYear());
        break;

      case "today": {
        // Explicit local date so analyse API matches client calendar day
        const todayLocal = start || new Date();
        const formattedDateToday = formatYMD(todayLocal);
        p = "5";
        dVal = formattedDateToday;
        from = formattedDateToday;
        to = formattedDateToday;
        label = `Today - ${formattedDateToday}`;
        break;
      }

      case "range":
        p = "4";
        label = `${fmtShort(start)} – ${fmtShort(end)}`;
        break;

      case "date":
        p = "5";
        dVal = from;
        label = fmtShort(start);
        break;

      default:
        p = "0";
        label = "All Time";
        break;
    }

    return {
      chartPeriod: p,
      chartDateSelected: dVal,
      fromParam: from,
      toParam: to,
      periodLabel: label,
    };
  }, [mode, start, end]);

  console.log(
    "[BrowseDiningSessions] search parameters (debug): f:" +
      (employeeFilterCsv || '""') +
      " p:" +
      (chartPeriod || '""') +
      " d:" +
      (chartDateSelected || '""') +
      " from:" +
      (fromParam || '""') +
      " to:" +
      (toParam || '""')
  );

  const DINING_SESSIONS_URL = useMemo(() => {
    if (!RestaurantID) return null;

    const base = `https://data.tablemate.net/customers`;
    const url =
      base +
      `?rid=${encodeURIComponent(RestaurantID)}` +
      `&dcid=2` +
      `&did=4` +
      `&p=${encodeURIComponent(chartPeriod || "3")}` +
      `&f=${encodeURIComponent(employeeFilterCsv || "")}` +
      `&d=${encodeURIComponent(chartDateSelected || "")}` +
      `&from=${encodeURIComponent(fromParam || "")}` +
      `&to=${encodeURIComponent(toParam || "")}`;

    console.log("[BrowseDiningSessions] URL:", url);

    return url;
  }, [
    RestaurantID,
    chartPeriod,
    employeeFilterCsv,
    chartDateSelected,
    fromParam,
    toParam,
  ]);

  const {
    busy: sessionsBusy,
    setBusy: setSessionsBusy,
    attempt: sessionsBusyAttempt,
    retry: retrySessions,
  } = useDataApiBusy(DINING_SESSIONS_URL);

  useEffect(() => {
    if (!DINING_SESSIONS_URL || !bearerToken) {
      if (!bearerToken) {
        console.log(
          "[BrowseDiningSessions] Skipping sessions fetch: no bearerToken yet."
        );
      }
      return;
    }

    const controller = new AbortController();

    async function loadDiningSessions() {
      console.log("[BrowseDiningSessions] Attempting to download.");
      try {
        setIsQuestionDataLoading(true);

        const proxiedUrl = `${REDIR_BASE}${encodeURIComponent(
          DINING_SESSIONS_URL
        )}`;

        console.log(
          "[BrowseDiningSessions] Downloading dining sessions:",
          proxiedUrl
        );

        const res = await fetch(proxiedUrl, {
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
            Authorization: bearerToken,
          },
        });

        if (!res.ok) {
          const busyErr = await busyErrorFrom(res);
          if (busyErr) {
            setSessionsBusy(busyErr);
            return;
          }
          const text = await res.text();
          console.error(
            "[BrowseDiningSessions] Failed to load sessions:",
            res.status,
            text
          );
          return;
        }

        setSessionsBusy(null);
        const data = await res.json();
        console.log("[BrowseDiningSessions] Dining sessions result:", data);

        // Flexible shape handling
        let sessions = [];
        if (Array.isArray(data)) {
          sessions = data;
        } else {
          sessions = data.sessions || [];
        }

        setSessionsList(sessions);

        // ✅ Reset detail panel if list changes
        setSelectedSession(null);
        setOrdersList([]);
        setRatingsList([]);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error loading sessions:", err);
        }
      } finally {
        setIsQuestionDataLoading(false);
      }
    }

    loadDiningSessions();
    return () => controller.abort();
  }, [DINING_SESSIONS_URL, bearerToken, sessionsBusyAttempt, setSessionsBusy]);

  // ✅ Helper to parse orders JSON safely
  const parseOrders = (ordersField) => {
    if (!ordersField) return [];
    if (Array.isArray(ordersField)) return ordersField;
    try {
      return JSON.parse(ordersField);
    } catch (e) {
      console.error("Failed to parse orders JSON:", e, ordersField);
      return [];
    }
  };

  // ✅ When a session is activated, update tabID + right side details
  const activateSession = (session, replace = false) => {
    if (!session) return;

    const newTabId = session.tab_id ?? session.id;
    setSessionTabID(String(newTabId));

    // Set selectedSession
    setSelectedSession(session);

    // Orders: parse JSON string from "orders" field
    const parsedOrders = parseOrders(session.orders);
    setOrdersList(parsedOrders);

    // Ratings: we already get an array as "ratings" in your data structure
    setRatingsList(Array.isArray(session.ratings) ? session.ratings : []);

    navigate(`/data/browse/dining/${newTabId}`, {
      replace,
    });
  };

  // Auto-activate first session if needed
  useEffect(() => {
    if (!sessionsList.length) return;

    const currentID = String(tabID);
    const hasCurrent = sessionsList.some(
      (s) => String(s.tab_id ?? s.id) === currentID
    );

    if (!hasCurrent) {
      const first = sessionsList[0];
      if (first) {
        activateSession(first, true);
      }
    } else if (!tabID || tabID === "0") {
      const current = sessionsList.find(
        (s) => String(s.tab_id ?? s.id) === currentID
      );
      if (current) {
        activateSession(current, true);
      }
    }
  }, [sessionsList, tabID]);

  const handleSessionClick = (session) => {
    activateSession(session, false);
  };

  // ✅ Convenience values for right panel
  const sessionCustomer = selectedSession?.customer || "Customer";
  const sessionDate = selectedSession?.date || "";
  const sessionTable = selectedSession?.tablenumber ?? selectedSession?.number;
  const sessionGuests = selectedSession?.occupants ?? "";
  const sessionWaiter = selectedSession?.waiter || "";
  const sessionAverageRating = Number(selectedSession?.average_rating || 0);
  const sessionTabTotal =
    ordersList.reduce(
      (sum, o) => sum + (parseFloat(o.total ?? o.cost ?? 0) || 0),
      0
    ) || 0;

  // ✅ NEW: filtered sessions based on search term
  const filteredSessions = useMemo(() => {
    if (!sessionSearchTerm.trim()) return sessionsList;

    const needle = sessionSearchTerm.toLowerCase();

    return sessionsList.filter((s) => {
      const pieces = [
        s.tab_id,
        s.id,
        s.customer,
        s.waiter,
        s.date,
        s.time,
        s.occupants,
        s.cost,
      ]
        .filter((x) => x !== undefined && x !== null)
        .map((x) => String(x).toLowerCase());

      return pieces.some((p) => p.includes(needle));
    });
  }, [sessionSearchTerm, sessionsList]);

  return (
    <div className="details-container-page browse-dining-page">
      <div className="row browse-dining-row">
        {/* LEFT: Session list */}
        <div className="col-md-4 browse-dining-sessions-col">
          <h4 className="select-a-session-title">Select a Session:</h4>

          {/* ✅ NEW: Search box above session list */}
          <div className="tm-session-search-bar" style={{ marginBottom: "10px" }}>
            <input
              type="text"
              className="form-control tm-session-search-input"
              placeholder="Search by customer, tab, host, date..."
              value={sessionSearchTerm}
              onChange={(e) => setSessionSearchTerm(e.target.value)}
            />
          </div>

          <div id="rating-quesionslist">
            {sessionsList && sessionsList.length > 0 ? (
              filteredSessions && filteredSessions.length > 0 ? (
                filteredSessions.map((q) => {
                  const aTab_id = q.tab_id ?? q.id;
                  const isActive = String(aTab_id) === String(tabID);
                  return (
                    <div
                      key={aTab_id}
                      className={`tm-session-row ${
                        isActive ? "tm-question-row-selected" : ""
                      }`}
                      onClick={() => handleSessionClick(q)}
                    >
                      <div className="tm-q-content">
                        <div className="tm-q-title-row">
                          <div className="tm-q">Tab ID: {q.tab_id}</div>
                          <Stars value={Number(q.average_rating || 0)} />
                          {q.customer || "Customer"}
                        </div>
                        <div className="tm-q-meta-row">
                          <div>
                            {q.date} - {q.time}
                          </div>
                          <span className="tm-q-status-label">
                            <div>
                              | Guests: {q.occupants} | BWP {q.cost}
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No dining sessions match your search.</p>
              )
            ) : (
              <p>No dining sessions found! Try again later.</p>
            )}
          </div>
        </div>

        {/* RIGHT: Session details */}
        <div className="col-md-8 browse-dining-detail-col">
          <center>
            <h5 className="dining-session-title">
              Customer Dining Session Data - Tab ID:{" "}
              {selectedSession?.tab_id ?? "-"} (Period: {periodLabel})
            </h5>
          </center>
          <div id="rating-quesions-data">
            {isQuestionDataLoading ? (
              <div className="chart-loader">
                <div className="chart-loader-spinner" />
                <span>Loading session data...</span>
              </div>
            ) : sessionsBusy ? (
              <BusyNotice message={sessionsBusy.message} onRetry={retrySessions} minHeight={220} />
            ) : !selectedSession ? (
              <p>Please select a session on the left.</p>
            ) : (
              <div id="dining-session-container">
                <div>
                  <strong>Customer: {sessionCustomer}</strong>
                </div>
                <br />
                <div id="tab-data" className="row">
                  <div className="col-md-6">
                    <div className="dining-session-cusomter-info">
                      Date: {sessionDate}
                    </div>
                    <div className="dining-session-cusomter-info">
                      Table: {sessionTable}
                    </div>
                    <div className="dining-session-cusomter-info">
                      Guests: {sessionGuests}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dining-session-cusomter-info">
                      Host: {sessionWaiter}
                    </div>
                    <div className="dining-session-cusomter-info">
                      Average Experience Rating:
                    </div>
                    <Stars value={sessionAverageRating} />
                  </div>
                </div>
                <hr />
                <div id="tab-data-orders-ratings" className="row">
                  <div className="col-md-6">
                    <h3 className="dining-session-cusomter-title">Orders:</h3>
                    <div className="dining-session-cusomter-tab-total">
                      Tab Total BWP {sessionTabTotal.toFixed(2)}
                    </div>
                    <div id="orderslist">
                      {ordersList && ordersList.length > 0 ? (
                        ordersList.map((o) => {
                          const tab_id = o.tab_id;
                          const isActive =
                            String(tab_id) === String(tabID);

                          return (
                            <div
                              key={o.id}
                              className={`tm-session-row ${
                                isActive ? "tm-session-row-selected" : ""
                              }`}
                            >
                              <div className="tm-q-leading">
                                <div className="tm-q">
                                  Order Number: {o.id}
                                </div>
                              </div>

                              <div className="tm-q-content">
                                <div className="tm-q-title-row">
                                  <span className="tm-q-title">
                                    {o.name || o.item_name || "Order item"}
                                  </span>
                                </div>

                                <div className="tm-q-type">
                                  <Stars
                                    value={Number(o.customer_rating || 0)}
                                  />
                                </div>

                                <div className="tm-q-preview">
                                  {o.size || ""}{" "}
                                  {o.specifications
                                    ? ` - ${o.specifications}`
                                    : ""}
                                </div>

                                <div className="tm-q-meta-row">
                                  <span className="tm-q-status-label">
                                    Qty: {o.quantity} | BWP{" "}
                                    {parseFloat(
                                      o.total ?? o.cost ?? 0
                                    ).toFixed(2)}
                                  </span>
                                  <span className="tm-q-id-label">
                                    {o.time}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p>No orders in this dining session.</p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h3 className="dining-session-cusomter-title">
                      Customer Review:
                    </h3>
                    <div id="ratingslist">
                      {ratingsList && ratingsList.length > 0 ? (
                        ratingsList.map((r) => {
                          const ratingValue =
                            r.type === "comment"
                              ? null
                              : Number(r.response || 0);

                          return (
                            <div
                              key={r.rating_column}
                              className="tm-question-row"
                            >
                              <div className="tm-q-leading">
                                <div className="tm-q-circle">
                                  {r.rating_column.replace("rate_", "")}
                                </div>
                              </div>

                              <div className="tm-q-content">
                                <div className="tm-q-title-row">
                                  <span className="tm-q-title">
                                    {r.title}
                                  </span>
                                </div>

                                <div className="tm-q-type">
                                  {ratingValue !== null ? (
                                    <Stars value={ratingValue} />
                                  ) : (
                                    <em>Comment</em>
                                  )}
                                </div>

                                <div className="tm-q-preview">
                                  <strong>{r.question}</strong>
                                  <br />
                                  {r.comment && r.comment !== "N/A" && (
                                    <span>“{r.comment}”</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p>No reviews for this dining session.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrowseDiningSessions;

/* ---------- Star control ---------- */
function Stars({ value = 0, onChange }) {
  const [hover, setHover] = useState(null);
  const numericValue = Number(value) || 0;
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span
          key={i}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(null)}
          onClick={() => onChange?.(i)}
          style={{
            fontSize: 20,
            cursor: onChange ? "pointer" : "default",
            color: (hover ?? numericValue) >= i ? "#ffbf00" : "#ccc",
          }}
          aria-label={`${i} star${i > 1 ? "s" : ""}`}
        >
          ★
        </span>
      ))}
    </div>
  );
}
